module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"TreatmentItemCreated":"შეიქმნა","TreatmentItemCancelled":"გაუქმდა","Recommendation":"რეკომენდებული დანიშნულება","Drug":"დაგენიშნა პრეპარატი"},"en":{"TreatmentItemCreated":"Created","TreatmentItemCancelled":"Cancelled","Recommendation":"Recommendation","Drug":"Drug"}}')
  delete Component.options._Ctor
}
